import { PageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";
import pageManagerConfigurationBase from "./PageManagerConfigurationBase.Generated";

const
    configuration: PageManagerConfiguration = {
        detailsPageMap: {
            ...pageManagerConfigurationBase.detailsPageMap,
        },
        indexPageMap: {
            ...pageManagerConfigurationBase.indexPageMap,
        },
        routes: {
            ...pageManagerConfigurationBase.routes,
            "/modules/reports/printreportdesigner/{recordId}/": async () => (await import("./Pages/PrintReportDesignerPage")).PrintReportDesignerPage,
        }
    };

export default configuration;